import type { RouteRecordRaw } from 'vue-router';
import { additionalAccountsLevelGuard } from '@/shared/additionalAccounts/router/additionalAccountsLevel.guard';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const AdditionalAccountsManagementPage = () =>
  import('../pages/AdditionalAccountsManagement/index.vue');

/**
 * El detalle de una cuenta adicional (ruta `additional-account-detail`) se
 * declara en `wallet/router/additionalWalletDetail.private.route.ts` — esa
 * page reusa la lógica real de `wallet` y un router de `additionalAccounts`
 * no puede importar un componente de `wallet` (crossModule).
 */
export const additionalAccountsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/gestion/cuentas',
    component: MainLayout,
    meta: {
      flag: 'feature_multi_accounts_b2b',
    },
    beforeEnter: additionalAccountsLevelGuard,
    children: [
      {
        path: '',
        name: 'additional-accounts-management',
        component: AdditionalAccountsManagementPage,
        meta: {
          requiresAuth: true,
          title: 'Gestiona tus cuentas',
        },
      },
    ],
  },
];
